import * as React from 'react';

type IMarkerPinIconProps = React.SVGAttributes<SVGSVGElement>;

export const MarkerPinIcon: React.FunctionComponent<IMarkerPinIconProps> = (props) => {
  return (
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.2671 12.1791C19.3809 13.2929 19.3809 15.0986 18.2671 16.2124C17.1533 17.3262 15.3475 17.3262 14.2338 16.2124C13.12 15.0986 13.12 13.2929 14.2338 12.1791C15.3475 11.0653 17.1533 11.0653 18.2671 12.1791Z"
        stroke="#1C1327"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5846 13.8324C25.5846 16.3671 24.4593 18.7711 22.5113 20.3937L19.4513 22.9444C18.2313 23.9617 17.3193 25.2977 16.8166 26.8044L16.2513 28.4991L15.686 26.8044C15.1833 25.2977 14.2713 23.9604 13.0513 22.9444L9.98997 20.3937C8.0433 18.7711 6.91797 16.3671 6.91797 13.8324V13.8804C6.91797 8.0564 11.7406 4.67773 16.2513 4.67773C20.762 4.67773 25.5846 8.0564 25.5846 13.8804"
        stroke="#1C1327"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MarkerPinIcon;
